export default __webpack_public_path__ + "static/satsanga-b99cc2b471a9a79b921c0f5412936371.png";